@if (!universityName) {
  <section class="fund-allocations-header">
    <h2>{{ title }}</h2>
    <form class="fundAllocationsForm" [formGroup]="yearOfStudyForm">
      <mat-form-field
        appearance="outline"
        subscriptSizing="dynamic"
        class="fundAllocationsFormField"
      >
        <mat-label>Year of study</mat-label>
        <mat-select
          formControlName="yearOfStudy"
          [(value)]="currentYear"
          (selectionChange)="onSelectionChange($event)"
        >
          @for (year of yearsOfFunding; track year) {
            <mat-option [value]="year">
              {{ year }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </form>
  </section>
}
